import { type CSSProperties, type JSX } from 'react';

import { PictureContainer, PictureImage } from './style';

export interface PictureProps {
  altText: string;
  className?: string;
  height?: number;
  png2xSrc?: string;
  pngSrc?: string;
  style?: CSSProperties;
  svgSrc?: string;
  webp2xSrc?: string;
  webpSrc?: string;
  width?: number;
}

export const Picture = ({
  altText,
  className,
  height,
  png2xSrc,
  pngSrc,
  style,
  svgSrc,
  webp2xSrc,
  webpSrc,
  width,
}: PictureProps): JSX.Element => {
  const pngSrcProps = {
    srcSet: `${pngSrc}${png2xSrc ? `, ${png2xSrc} 2x` : ''}`,
    type: 'image/png',
  };

  const webpSrcProps = webpSrc
    ? {
        srcSet: `${webpSrc}${webp2xSrc ? `, ${webp2xSrc} 2x` : ''}`,
        type: 'image/webp',
      }
    : {};

  const imgProps = {
    alt: altText,
    className,
    height,
    src: typeof svgSrc !== 'undefined' ? svgSrc : pngSrc,
    width,
  };

  return typeof svgSrc !== 'undefined' ? (
    <PictureContainer>
      <PictureImage {...imgProps} style={style} />
    </PictureContainer>
  ) : (
    <PictureContainer>
      {!!webpSrc && <source {...webpSrcProps} />}
      <source {...pngSrcProps} />
      <PictureImage {...imgProps} style={style} />
    </PictureContainer>
  );
};
